/* eslint-disable max-len */
import { } from 'types';
import * as yup from 'yup';
import { v4 as uuidv4 } from 'uuid';

import { blogFirstKey } from './constant';

export const makeContentInitData = () => {
  const initialMultipleInstructions = {
    id: uuidv4(),
    descriptionAm: null,
    descriptionEn: null,
    descriptionRu: null,
    image: null,
  }

  return initialMultipleInstructions
}

export const initialFormState = {
  titleAm: '',
  titleEn: '',
  titleRu: '',
  minRead: 1,
  visible: true,
  activeInHome: false,
  postedDate: new Date(),
  [blogFirstKey]: [makeContentInitData()],
}

const imageListSchemaOptional = yup.mixed()
  .test(
    'is-files-length',
    'You can upload maximum 5 pictures',
    (value) => Object.keys(value || {}).length <= 2
  )
  .nullable()

const content = yup.array()
  .of(yup.object({
    descriptionAm: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
    descriptionEn: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
    descriptionRu: yup.string().optional().max(10000, 'Description must contain at least maximum length 10000').nullable(),
    images: imageListSchemaOptional,
  }))

export const createBlogSchema = yup.object().shape({
  titleAm: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  titleEn: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  titleRu: yup.string().required('Title is required.').max(250, 'Title must contain at least maximum length 250'),
  visible: yup.boolean().required(),
  activeInHome: yup.boolean().required(),
  minRead: yup.number().required(),
  postedDate: yup.string().required(),
  content,
});
